import React, { useEffect, useRef, useState } from "react";
// import countries from "../../Utils/ListOfCountries";
// import ErrorMessage from "../Common/ErrorMessage";
import countries from "../../../../utils/ListOfCountries";
import ErrorMessage from "../../../common/ErrorMessage";
import { isEmpty, isNaN, isUndefined, toNumber, toUpper } from "lodash";

const ConfrimCreditModal = ({ amountToCredit, handleStripe, onClose, codeAlreadyApplied }) => {
	const [errorMessageVAT, setErrorMessageVAT] = useState(null);
	const [billingAddress, setBillingAddress] = useState("");
	const [billingCity, setBillingCity] = useState("");
	const [billingState, setBillingState] = useState("");
	const [billingZip, setBillingZip] = useState("");
	const [taxAmt, setTaxAmt] = useState(0);
	const [topUpAmount, setTopUpAmount] = useState(0);
	const [totalAmt, setTotalAmt] = useState(0);
	const [vatCode, setVatCode] = useState("");
	const [selectedCountryCode, setSelectedCountryCode] = useState("Select Country");
	const [disableSubmit, setDisableSubmit] = useState(true);

	const nameInput = useRef(null);
	const verifyBtn = useRef(null);

	const euISOCodes = [
		"BE", "BG", "CZ", "DK", "DE", "EE", "IE", "GR", "ES", "FR", "HR", "IT", "CY",
		"LV", "LT", "LU", "HU", "MT", "NL", "AT", "PL", "PT", "RO", "SI", "SK", "FI", "SE",
	];

	useEffect(() => {
		totalAmtCalc(taxAmt, Number(amountToCredit));
	}, []);

	useEffect(() => {
		checkForEmptyField();
	}, [billingAddress, billingCity, billingState, billingZip, selectedCountryCode]);

	const validateVatNumber = (vatNumber) => {
		if (isEmpty(vatNumber)) return true;
		if (isUndefined(vatNumber)) return false;
		if (vatNumber.length !== 11) return false;

		const vatISO = toUpper(vatNumber.substr(0, 2));
		if (!euISOCodes.includes(vatISO)) return false;

		const vatDigits = toNumber(vatNumber.substr(2));
		return !isNaN(vatDigits);
	};

	const checkForEmptyField = () => {
		// If vatcode is mandatory, enable the below code 
		// if (vatCode.length > 0) {
		// 	if (!validateVatNumber(vatCode)) {
		// 		setDisableSubmit(true);
		// 	} else {
		// 		setDisableSubmit(false);
		// 	}
		// }

		if (billingAddress?.length === 0 || billingCity?.length === 0 || billingState?.length === 0 || billingZip?.length === 0 || selectedCountryCode?.length === 0 || selectedCountryCode === "Select Country") {
			setDisableSubmit(true);
		} else {
			setDisableSubmit(false);
		}
	};

	const totalAmtCalc = (percentValue, topupAmt, callback) => {
		setTopUpAmount(topupAmt);
		const ttlAmt = parseFloat(percentValue) + parseFloat(topupAmt);
		setTotalAmt(ttlAmt);
		if (callback) callback();
	};

	const handleSubmitAmount = () => {

		handleStripe(totalAmt, topUpAmount, taxAmt);
	};

	const checkVATNumber = (e) => {
		const vatNumber = e.target.value;
		let data = validateVatNumber(vatNumber);
		if (vatNumber.length === 0) data = false;

		let vatPercentAmt = 0;
		const isEU = euISOCodes.includes(selectedCountryCode);

		if (vatNumber.length > 0 && !data) {
			setErrorMessageVAT("VAT number is not valid");
		}

		if (!data) {
			vatPercentAmt = isEU || selectedCountryCode === "GB"
				? (0.2 * Number(amountToCredit)).toFixed(2)
				: 0;
		}

		if (data) {
			if (selectedCountryCode === "GB") {
				vatPercentAmt = (0.2 * Number(amountToCredit)).toFixed(2);
			} else if (isEU) {
				vatPercentAmt = 0;
			}
		}

		setTaxAmt(vatPercentAmt);
		totalAmtCalc(vatPercentAmt, Number(amountToCredit));
	};

	const updateVat = (e) => {
		const code = e.target.value;
		setVatCode(code);
		let vatPercentAmt = 0;
		const isEU = euISOCodes.includes(selectedCountryCode);

		if (!code.length) {
			if (!selectedCountryCode || selectedCountryCode === "Select Country") {
				setTaxAmt(vatPercentAmt);
			} else if (isEU || selectedCountryCode === "GB") {
				vatPercentAmt = (0.2 * Number(amountToCredit)).toFixed(2);
				setTaxAmt(vatPercentAmt);
			}
		} else if (selectedCountryCode === "GB") {
			vatPercentAmt = (0.2 * Number(amountToCredit)).toFixed(2);
			setTaxAmt(vatPercentAmt);
		}

		totalAmtCalc(vatPercentAmt, Number(amountToCredit));
	};

	const selectCountry = (e) => {
		const selected = e.target.value;
		if (vatCode.length > 0 && !validateVatNumber(vatCode)) {
			nameInput.current.focus();
		}

		let vatPercentAmt = 0;
		const isEU = euISOCodes.includes(selected);
		const isUK = selected === "GB";

		if (!vatCode && (isEU || isUK)) {
			vatPercentAmt = (0.2 * Number(amountToCredit)).toFixed(2);
		}

		setTaxAmt(vatPercentAmt);
		totalAmtCalc(vatPercentAmt, Number(amountToCredit));
		setSelectedCountryCode(selected);
	};

	return (
		<div className="main-billing-modal-div">
			<div className="confirmCredit-header flex items-center">
				<a onClick={() => onClose(codeAlreadyApplied)}>
					<img
						style={{ width: "16px", height: "15px", marginRight: "10px" }}
						src="/img/header-back-arrow@2x.png"
						alt=""
					/>
				</a>
				<h3 className="text-size-25 font-semibold">Confirm credit</h3>
			</div>

			<div className="flex">
				<div className="billing-address mt-3">
					<p className="fs14 font600 mb-4">Please enter your billing address</p>
					<form className="billing-form">
						<div className="form-group" style={{ width: "380px" }}>
							<label htmlFor="companyName">Company Name</label>
							<input type="text" id="companyName" className="form-control form-control-lg form-input-box-380-reverse remove-outline" />
						</div>
						<div className="form-group" style={{ width: "380px" }}>
							<label htmlFor="vatNumber">VAT number (optional)</label>
							<input
								id="vatNumber"
								type="text"
								ref={nameInput}
								onBlur={checkVATNumber}
								onChange={updateVat}
								className="form-control form-control-lg form-input-box-380-reverse remove-outline"
							/>
							{errorMessageVAT && <ErrorMessage message={errorMessageVAT} />}
						</div>
						{[
							["Address", billingAddress, setBillingAddress, "addressBill"],
							["City", billingCity, setBillingCity, "cityBill"],
							["State", billingState, setBillingState, "stateBill"],
							["Postal code / ZIP", billingZip, setBillingZip, "zipcodeBill"],
						].map(([label, value, setter, id]) => (
							<div key={id} className="form-group" style={{ width: "380px" }}>
								<label htmlFor={id}>
									{label} <span>*</span>
								</label>
								<input
									id={id}
									type="text"
									className="form-control form-control-lg form-input-box-380-reverse remove-outline"
									onChange={(e) => {
										setter(e.target.value);
									}}
								/>
							</div>
						))}

						<div className="form-group">
							<label htmlFor="countryBill">Country <span>*</span></label>
							<select
								id="countryBill"
								onChange={selectCountry}
								className="form-control form-input-box-380-reverse"
								style={{ fontSize: "1rem", color: "#666666" }}
							>
								<option>Select Country</option>
								{countries.map((country, i) => (
									<option key={i} value={country.code}>{country.name}</option>
								))}
							</select>
						</div>
					</form>
				</div>

				<div className="px-4 py2 purchase-amt">
					<p className="fs14 font600 mb-30">Your purchase</p>
					<div className="flex flex-col">
						<div className="my-2 flex justify-between">
							<span className="fs14">Credit</span>
							<span className="fs14 font600">${parseFloat(amountToCredit).toFixed(2)}</span>
						</div>
						<div className="my-2 flex justify-between">
							<span className="fs14">Tax</span>
							<span className="fs14 font600">${taxAmt}</span>
						</div>
						<div className="my-2 flex justify-between items-center total-bill-div p-1">
							<span className="fs16 font600">Total</span>
							<span className="fs16 font600">${parseFloat(totalAmt).toFixed(2)}</span>
						</div>
						<div>
							<span style={{ fontSize: "10px" }}>
								* VAT is charged at UK rates to UK customers, and EU customers
								who are unable to provide a VAT number.
								<br />
								Other users will be responsible for paying any applicable taxes locally.
								EU companies should provide a VAT number, and will not be charged UK VAT.
							</span>
						</div>
					</div>
				</div>
			</div>

			<div className="form-group code-form-group mt-3 py-2 px-4">
				<button
					onClick={handleSubmitAmount}
					className="btn btn-block btn-lg btn-icon confirm-billing-btn"
					disabled={disableSubmit}
					ref={verifyBtn}
				>
					Confirm
				</button>
			</div>
		</div>
	);
};

export default ConfrimCreditModal;
